import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 30px;
`;

export const LoadMoreButton = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  margin-left: 38px;
`;
